import React from "react";
import { useContextProvider } from "../../context";
import { Language } from "../../types";
import whatsappIcon from "./whatsapp.svg";
import telegramIcon from "./telegram.svg";
import facebookIcon from "./fb.svg";
import instagramIcon from "./ig.svg";
import "./index.css";

const currentYear = new Date().getFullYear();

const dict = {
  [Language.English]: {
    phone: "Phone: +34 642 263 271",
    copyright: `Copyright © ${currentYear} car-rent.vip`,
    email: "E-mail: info@car-rent.vip",
    message: "Hello! I have a question about the car rental service.",
  },
  [Language.Spanish]: {
    phone: "Teléfono: +34 642 263 271",
    copyright: `Derechos de autor © ${currentYear} car-rent.vip`,
    email: "E-mail: info@car-rent.vip",
    message:
      "Hola! Tengo una pregunta sobre el servicio de alquiler de coches.",
  },
  [Language.Russian]: {
    phone: "Телефон: +34 642 263 271",
    copyright: `Авторские права © ${currentYear} car-rent.vip`,
    email: "E-mail: info@car-rent.vip",
    message: "Здравствуйте! У меня есть вопрос о сервисе аренды автомобилей.",
  },
  [Language.Ukrainian]: {
    phone: "Телефон: +34 642 263 271",
    copyright: `Авторські права © ${currentYear} car-rent.vip`,
    email: "E-mail: info@car-rent.vip",
    message: "Привіт! У мене є питання про сервіс оренди автомобілів.",
  },
};

export const Footer: React.FC = () => {
  const { language } = useContextProvider();
  const { phone, copyright, email } = dict[language];
  const message = encodeURIComponent(dict[language].message);

  return (
    <section className="Footer">
      <div>
        <strong>car-rent.vip</strong>
      </div>
      <a className="Footer-link" href={`tel:+34642263271`}>
        {phone}
      </a>
      <a className="Footer-link" href={`mailto:info@car-rent.vip`}>
        {email}
      </a>
      <div className="Footer-icons">
        <a
          href={`https://wa.me/+34642263271?text=${message}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={whatsappIcon} alt="WhatsApp icon" />
        </a>
        <a
          href={`https://t.me/Konstantin_Modin?text=${message}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={telegramIcon} alt="Telegram icon" />
        </a>
        <a
          href="https://www.instagram.com/car_rent_alicante/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={instagramIcon} alt="Instagram icon" />
        </a>
        <a
          href="https://www.facebook.com/groups/carrent.vip"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={facebookIcon} alt="Facebook icon" />
        </a>
      </div>
      {copyright}
    </section>
  );
};
